import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBreakRecordsByParentRecordId } from '../services/getBreakRecordsByParentRecordId.service';

export const getRecordsBreakRecords = createAsyncThunk(
  'records/getRecordsBreakRecords',
  async ({ projectId, parentRecordId }, { getState }) => {
    const records = await getBreakRecordsByParentRecordId(
      projectId,
      parentRecordId
    );

    return records;
  }
);
